import { Colors } from '@src/colors';
import styled from 'styled-components';

export const SVG = styled.svg`
    &.v-ui-icon {
        width: 24px;
        height: 24px;
        fill:${Colors.grayOne};
    }
    &.btn-v-primary {
        border: none;
        color: @color("dusk");
        background-color: ${Colors.guestYellow};
        text-align: center;
        font-size: 1em;
        line-height: 1.5em;
        padding: 0.5em 1em;
        transition: all 0.2s;
        &:hover,
        &.is-hovered {
            background-color: ${Colors.guestYellow};
        }
        &:active,
        &:focus,
        &.is-active,
        &.is-focused {
            outline: ${Colors.lake} auto 4px;
        }

        &.is-disabled {
            opacity: 0.5;
            pointer-events: none;
        }
        &.is-selected {
            background-color: ${Colors.guestYellow};
            box-shadow: inset 0 1px 4px 0 ${Colors.awareness};
        }
    }

    &.btn-v-utility {
        background: white;
        border: 1px solid #b3c2c8;
        color: #003349;
        font-size: 1em;
        line-height: 1.5em;
        padding: 0.5em 1em;
        transition: all 0.2s;
        &:hover,
        &.is-hovered {
            background-color: ${Colors.midnight4};
        }
        &:active,
        &:focus,
        &.is-active,
        &.is-focused {
            outline: ${Colors.lake} auto 4px;
        }
        &.is-disabled {
            opacity: 0.5;
            pointer-events: none;
        }
        &.is-selected {
            background-color: ${Colors.midnight4};
            border: 1px solid ${Colors.grayThree};
            box-shadow: inset 0 1px 4px 0 ${Colors.grayFive};
            border-radius: 2px;
        }
`;
